import { createAction, props } from "@ngrx/store";

export const loadUserPermissionInquiryInit = createAction('[User Permission Inquiry] Load User Permission Inquiry Init', props<{ request: any }>());
export const loadUserPermissionInquirySuccess = createAction('[User Permission Inquiry] Load User Permission Inquiry Success', props<{ response: any }>());
export const loadUserPermisisonInquiryFailure = createAction('[User Permission Inquiry] Load User Permission Inquiry Failure', props<{ error: string }>());
